<template>
  <Swiper @swiper="onSwiper" class="swiper">
    <swiper-slide class="swiper-no-swiping">
      <DocumentsReserveListContent
        :hide-return="hideReturn"
        @back="$emit('back')"
        @continue="toggleDocument = false"
        @add-document="handleSlideTo(1)"
      >
        <template #prepend>
          <slot name="prepend" />
        </template>
      </DocumentsReserveListContent>
    </swiper-slide>
    <swiper-slide class="swiper-no-swiping">
      <AddDocumentReserveContent
        @cancel="handleSlideTo(0)"
        @continue="onContinue"
        @add-document="handleSlideTo(1)"
      >
      </AddDocumentReserveContent>
    </swiper-slide>
  </Swiper>
</template>

<script lang="ts" setup>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { ref } from 'vue';
  import DocumentsReserveListContent from './documents/DocumentsReserveListContent.vue';
  import AddDocumentReserveContent from './documents/AddDocumentReserveContent.vue';
  import { useProfile } from '@/composables/useProfile';
  const { toggleDocument } = useProfile();

  const emit = defineEmits(['continue', 'back', 'refresh-documents']);

  defineProps({
    hideReturn: {
      type: Boolean,
      default: false,
    },
  });

  const swiperInstance = ref();
  const selectedSwiper = ref(0);

  const handleSlideTo = (idx: number) => {
    selectedSwiper.value = idx;
    swiperInstance.value?.slideTo(selectedSwiper.value);
  };

  const onSwiper = (swiper: any) => {
    swiperInstance.value = swiper;
    swiperInstance.value?.slideTo(selectedSwiper.value);
  };

  const onContinue = () => {
    handleSlideTo(0);
    emit('refresh-documents');
  };
</script>

<style lang="scss" scoped>
  ion-modal {
    --height: auto;
  }

  ion-item {
    --ion-background-color: white !important;
  }

  .justify-space-between {
    justify-content: space-between;
  }

  .custom-select {
    border: solid 1px #bcbcbc;
    border-radius: 30px;
    padding: 0px 30px;
  }

  :host(.select-label-placement-floating) .select-wrapper {
    margin-top: -5px !important;
  }
</style>
